export const getIframeUrl = state => state.iframe.url;
export const getIframeTitle = state => state.iframe.title;
